import isArrayLike from './is-array-like';
export default function head(o) {
  if (isArrayLike(o)) {
    return o[0];
  }
  return undefined;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/head.js
// module id = 51
// module chunks = 0